export function getQueryString(name) {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  const r = window.location.search.substr(1).match(reg)
  if (r !== null) {
    return r[2]
  } else {
    return ''
  }
}



// WEBPACK FOOTER //
// ./src/utils/common.js